<div>
  <mat-expansion-panel class="issue-panel">
    <mat-expansion-panel-header>
      <mat-panel-title> Report a problem or issue for a workstation </mat-panel-title>
    </mat-expansion-panel-header>
    <mat-divider></mat-divider>
    <div class="mt-2 flex-container">
      <app-ods-input class="item" [labelText]="'Location *'" [labelFor]="'locationSelect'" [labelId]="'locationLabel'">
        <mat-form-field>
          <mat-select
            id="locationSelect"
            aria-label="Select Location to create issue for"
            [(value)]="selectedBuildingId"
            required
          >
            <mat-option *ngFor="let building of (buildings$ | async) ?? []" [value]="building.id">
              {{ building.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-ods-input>

      <app-ods-input class="item" [labelText]="'Floor *'" [labelFor]="'selectFloor'" [labelId]="'floorLabel'">
        <mat-form-field>
          <mat-select
            id="selectFloor"
            aria-label="Select floor to create issue for"
            aria-labelledby="floorLabel"
            [(value)]="selectedFloorId"
            required
          >
            <mat-option *ngFor="let floor of floors" [value]="floor.id">
              {{ floor.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-ods-input>

      <app-ods-input [labelText]="'Desk No. *'" [labelFor]="'deskNumberSelect'" [labelId]="'deskNumberLabel'">
        <mat-form-field>
          <mat-select
            id="deskNumberSelect"
            [(value)]="selectedDeskId"
            aria-label="Select a desk to report an issue for"
            required
          >
            <mat-option>
              <ngx-mat-select-search
                [ariaLabel]="'Search for desk'"
                [formControl]="workstationSearch"
                [placeholderLabel]="'Search'"
                [noEntriesFoundLabel]="noResultsLabel"
              ></ngx-mat-select-search>
            </mat-option>

            <mat-option *ngFor="let workstation of filteredWorkstations | async" [value]="workstation.id">
              {{ workstation.number }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </app-ods-input>
    </div>
    <div class="mb-2">
      <app-ods-input
        [labelText]="'Description * (Do not include any personal information in the description)'"
        [labelFor]="'issueDescription'"
        [labelId]="'descriptionLabel'"
      >
        <mat-form-field class="example-full-width">
          <textarea
            id="issueDescription"
            matInput
            rows="10"
            [(ngModel)]="issue"
            aria-label="Enter your issue with the selected workstation"
            required
          ></textarea>
        </mat-form-field>
      </app-ods-input>
    </div>
    <mat-divider></mat-divider>
    <div class="mt-2 action-container">
      <button mat-raised-button color="primary" (click)="reportIssue()">Send</button>
    </div>
  </mat-expansion-panel>
</div>
